import { useThreadComposerLayout } from "./threadComposerLayoutContext";
import { parseScopedThreadKey } from "@cmmd-forge/client-runtime";
import { AssistantSelectionToolbar } from "./AssistantSelectionToolbar";
import { insertAssistantCitationInDraft } from "./insertAssistantCitationInDraft";

export function TimelineCitationActions({
  viewport,
  routeThreadKey,
}: {
  readonly viewport: HTMLElement | null;
  readonly routeThreadKey: string;
}) {
  const { citeAssistantText } = useThreadComposerLayout();
  const threadRef = parseScopedThreadKey(routeThreadKey);
  return threadRef ? (
    <AssistantSelectionToolbar
      viewport={viewport}
      threadRef={threadRef}
      onCite={(citation, anchor) =>
        citeAssistantText(citation, anchor) || insertAssistantCitationInDraft(threadRef, citation)
      }
    />
  ) : null;
}
